import {
	checkIsExtendedPhonePrefix,
	type ExtendedPhonePrefixEnumType,
} from '../phonePrefixes';

export const checkIsPhonePrefix = (
	value: unknown,
): value is ExtendedPhonePrefixEnumType =>
	typeof value === 'string' && checkIsExtendedPhonePrefix(value);
